import { spawn } from 'redux-saga/effects';

import { sagas as listSagas } from './listModule';
import { sagas as compareSagas } from './compareModule';

export default function* zoneSagas() {
	yield spawn(listSagas);
	yield spawn(compareSagas);
}
